// extracted by mini-css-extract-plugin
export default {"soundVolume":"SoundVolume_soundVolume__nbzyP","soundVolumeAnimate":"SoundVolume_soundVolumeAnimate__p0cEP","soundAnimation":"SoundVolume_soundAnimation__UPsdL"};